<script setup>
import JobEditPage from '@/views/Previews/Jobs/JobEditPage.vue'
import { AccessPageMeta } from '@/access/accessPageMeta'

definePage({ meta: AccessPageMeta.Projects.preview.meta })
</script>

<template>
  <JobEditPage />
</template>
